import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'upsc-element-blocker',
  templateUrl: './element-blocker.component.html',
  styleUrls: ['./element-blocker.component.scss'],
})
export class ElementBlockerComponent implements OnInit, OnDestroy {
  @Input() isPageBlocker = false;
  @Input() theme = 'light';

  @ViewChild('backdrop', { static: true }) public backdrop: ElementRef;

  private htmlEl = document.getElementsByTagName('html')[0];

  constructor() {
  }

  public ngOnInit() {
    if (this.isPageBlocker) {
      this.htmlEl.style.overflow = 'hidden';
    }
  }

  public ngOnDestroy() {
    this.htmlEl.style.overflow = 'auto';
  }

  public setHeight(height: string) {
    this.backdrop.nativeElement.style.height = height;
  }
}
